import { nextLine, bold, nextParagraph } from "components/mlpaUiComponents/LegalNote/lib";
import { capitalize } from "lodash";

export default {
  label: "Error Reports",
  errorDescription: "Error Description",
  certificateCode: "ZEREZ ID",
  certificateHolder: "Certificate Holder",
  correctionExplanation: "Reply/Explanation",
  status: "Status",
  errorType: "Error Type",
  reportedOn: "Reported On",
  reportedBy: "Reported By",
  resolvedOn: "Resolved On",
  resolvedBy: "Resolved By",
  openSince: "Open Since (Days)",
  totalErrorReports: "# Error Reports",
  discardErrorReport: "Discard Error Report",
  closeErrorReportModalNote: ({
    firstName,
    lastName,
    email,
  }: {
    firstName?: string;
    lastName?: string;
    email?: string;
  }) => `Hello ${capitalize(firstName) + capitalize(lastName)}, 
            ${nextLine()}should this error report actually be closed??
            ${nextLine()}This email address will be stored for further processing: ${bold(email ?? "")}
            ${nextParagraph()}A written explanation as to why this error report is being rejected is mandatory:`,
  errorReportClosedBy: ({ firstName, lastName, email }: { firstName?: string; lastName?: string; email?: string }) =>
    `closed by ${capitalize(firstName) + (lastName && ` ${capitalize(lastName)}`)}: ${email ?? ""}`,
};
